import { render, staticRenderFns } from "./ShellChooser.vue?vue&type=template&id=62e67fa2"
import script from "./ShellChooser.vue?vue&type=script&lang=js"
export * from "./ShellChooser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports